import { render, staticRenderFns } from "./finshs.vue?vue&type=template&id=24af102b&scoped=true&"
import script from "./finshs.vue?vue&type=script&lang=js&"
export * from "./finshs.vue?vue&type=script&lang=js&"
import style0 from "./finshs.vue?vue&type=style&index=0&id=24af102b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af102b",
  null
  
)

export default component.exports